// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".point[data-v-2253a366]{position:absolute;left:10px;bottom:100px;color:#fff;z-index:1}.point .icon[data-v-2253a366]{display:block;font-size:34px}.point .icon[data-v-2253a366]:hover{color:#cf421f}", ""]);
// Exports
module.exports = exports;
